// src/myPlans/PlanConfirmation.js

import React, { useState } from 'react';
import './planConfirmation.css';
import { getFunctions, httpsCallable } from 'firebase/functions';

export default function PlanConfirmation({
  onClose,
  price,
  paymentMethod,
  selectedQuantity,
  planType,
  paymentInterval,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const formatted = `$${price.toFixed(2)}`;
  const billedAnnually = price / 12 === Math.round(price / 12);

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);

    // Log the payload before sending
    const payload = { selectedQuantity, planType, paymentInterval };
    // console.log('updateStripeSubscription payload:', payload);

    try {
      const functions = getFunctions();
      const updateSub = httpsCallable(functions, 'updateStripeSubscription');
      const { data } = await updateSub(payload);
    //   console.log('Subscription updated:', data);
      onClose();
    } catch (err) {
    //   console.error('Error updating subscription:', err);
    //   setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="plan-confirmation-overlay">
      <div className="plan-confirmation-modal">
        <div className="plan-confirmation-header">
          <h2>Confirm changes</h2>
          <button
            className="plan-confirmation-close"
            aria-label="Close"
            onClick={onClose}
            disabled={loading}
          >
            ×
          </button>
        </div>

        <div className="plan-confirmation-body">
          <div className="plan-confirmation-row">
            <div>
              <div className="plan-confirmation-title">
                Bumpups Pro subscription
              </div>
              <div className="plan-confirmation-subtitle">
                {billedAnnually ? 'Billed annually' : 'Billed monthly'},{' '}
                starting today
              </div>
            </div>
            <div className="plan-confirmation-value">{formatted}</div>
          </div>

          <hr />

          <div className="plan-confirmation-row">
            <div className="plan-confirmation-title">Payment Method</div>
            <div className="plan-confirmation-value">
              {paymentMethod || '--'}
            </div>
          </div>

          {error && (
            <div className="plan-confirmation-error">
              {error}
            </div>
          )}
        </div>

        <div className="plan-confirmation-footer">
          <button
            className="plan-cancel-button"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="plan-confirm-button"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Processing…' : 'Pay now'}
          </button>
        </div>
      </div>
    </div>
  );
}
